export const signUpInitialState = {
  name: "",
  email: "",
  password: "",
  confirmPassword: "",
};

export const loginInitialState = {
  email: "",
  password: "",
};

export const addContactDetailsInitialState = {
  name: "",
  email: "",
  number: "",
  whatsApp: "",
  company: "",
  profileURL: "",
};
